/**
 * API Configuration
 * 
 * This file contains configuration for API endpoints.
 * It uses environment variables with sensible defaults.
 */

// Get environment variables with fallbacks
const getEnvVar = (key, defaultValue) => {
  if (import.meta.env[key] !== undefined) {
    return import.meta.env[key];
  }
  return defaultValue;
};

// Environment detection
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// API Base URL configuration
export const API_BASE_URL = getEnvVar(
  'VITE_API_BASE_URL',
  isProduction 
    ? 'https://wellfedcats.com/api'
    : 'http://localhost:8080/api'
);

/**
 * Constructs a full API URL from the given path
 * @param {string} path - The API path (without leading slash)
 * @returns {string} - The full API URL
 */
export const apiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
  return `${API_BASE_URL}/${normalizedPath}`;
};

// Common API endpoints
export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    // User authentication
    LOGIN_USER: apiUrl('auth/user/login'),
    REGISTER_USER: apiUrl('auth/user/register'),
    // Feeder authentication
    LOGIN_FEEDER: apiUrl('auth/feeder/login'),
    REGISTER_FEEDER: apiUrl('auth/feeder/register'),
    // Common auth endpoints
    GOOGLE: apiUrl('auth/google'),
    PROFILE: apiUrl('user/profile'),
    FEEDER_PROFILE: apiUrl('feeder/profile'),
  },
  
  // Cat endpoints
  CATS: {
    LIST: apiUrl('cat/all'),
    DETAILS: (id) => apiUrl(`cat/${id}`),
    COUNT: apiUrl('cat/count'),
  },
  
  // Feeding endpoints
  FEEDING: {
    CREATE: (catId) => apiUrl(`feeding/cat/${catId}`),
    LIST_FOR_CAT: (catId) => apiUrl(`feeding/cat/${catId}`),
    LAST_FOR_CAT: (catId) => apiUrl(`feeding/cat/${catId}/last`),
  },
  
  // Feeding request endpoints
  FEEDING_REQUEST: {
    CREATE: (catId) => apiUrl(`feeding-request/cat/${catId}`),
    LIST: apiUrl('feeding-request'),
    OPEN: apiUrl('feeding-request/open'),
    PROCESSED: apiUrl('feeding-request/processed'),
    STATS: apiUrl('feeding-request/stats'),
  },
  
  // Notification endpoints
  NOTIFICATIONS: {
    VAPID_KEY: apiUrl('notifications/vapid-public-key'),
    SUBSCRIBE: apiUrl('notifications/subscribe'),
    UNSUBSCRIBE: apiUrl('notifications/unsubscribe'),
    IS_SUBSCRIBED: apiUrl('notifications/is-subscribed'),
  },
};

export default {
  API_BASE_URL,
  ENDPOINTS,
  apiUrl,
  isDevelopment,
  isProduction,
}; 